// Function to limit content to first 20 words
const limitWords = (text, wordCount = 20) => {
    if (!text) return '';
    const words = text.split(' ');
    return words.slice(0, wordCount).join(' ') + (words.length > wordCount ? '...' : '');
};

export default limitWords;